module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAA1CAMAAABlcHtYAAAAOVBMVEUAAAD///////////////////////////////////////////////////////////////////////8KOjVvAAAAEnRSTlMA3yDvz4AwEGBQcL+foECvkI9iNskaAAAAsElEQVQ4y73UVwoDMQwEUNf1umyJ7n/YkCJ/RPI4gbDz+zCGkZDRkwOFPLCVHtn1d/RM1Wzx9Ipizr7NA6MGzLpPS8jC2MzB5hdhjTjSYrcVWPzJCrDc7RyXTZsw1y2AQkOalj23edmVzbu/lW0sWzEybFXI7GVBf5pNW5ueKhQ0hBYZNo/niTcB7FBTzwDnBjUqGr/UAhQPQT9QxwVDSEhPA4bg8dXUsovpySFkeOPv1Z8f/UtKiMMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/euro/icon-left.png
// module id = 1Cw0
// module chunks = 0